import * as Bixby from './../../core';


export interface CloDealManagerState {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
  cloDealManagers?: Bixby.Models.CloDealManager[];
  isAddingCloDealManagerToClient: boolean;
  isDeletingCloDealManagerFromClient?: boolean;
}

export const ALL_CLO_DEAL_MANAGER_LOADING = "CLO_DEAL_MANAGER_LOADING";
export const ALL_CLO_DEAL_MANAGER_SUCCESS = 'ALL_CLO_DEAL_MANAGER_SUCCESS';
export const ALL_CLO_DEAL_MANAGER_FAILURE = 'ALL_CLO_DEAL_MANAGER_SUCCESS';
export const ADD_CLIENT_CLO_DEAL_MANAGER = 'ADD_CLIENT_CLO_DEAL_MANAGER';
export const ADD_CLIENT_CLO_DEAL_MANAGER_FAILURE = 'ADD_CLIENT_CLO_DEAL_MANAGER_FAILURE';
export const ADD_CLIENT_CLO_DEAL_MANAGER_SUCCESS = "ADD_CLIENT_CLO_DEAL_MANAGER_SUCCESS";
export const DELETE_CLIENT_CLO_DEAL_MANAGER = 'DELETE_CLIENT_CLO_DEAL_MANAGER';
export const DELETE_CLIENT_CLO_DEAL_MANAGER_FAILURE = 'DELETE_CLIENT_CLO_DEAL_MANAGER_FAILURE';
export const DELETE_CLIENT_CLO_DEAL_MANAGER_SUCCESS = "DELETE_CLIENT_CLO_DEAL_MANAGER_SUCCESS";

interface AllCloDealManagerLoading extends Bixby.Models.BixbyAction<undefined, typeof ALL_CLO_DEAL_MANAGER_LOADING> {
  type: typeof ALL_CLO_DEAL_MANAGER_LOADING;
}

interface AllCloDealManagerSuccess extends Bixby.Models.BixbyAction<Bixby.Models.CloDealManager[], typeof ALL_CLO_DEAL_MANAGER_SUCCESS> {
  type: typeof ALL_CLO_DEAL_MANAGER_SUCCESS;
  payload: Bixby.Models.CloDealManager[];
}

interface AllCloDealManagerFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof ALL_CLO_DEAL_MANAGER_FAILURE> {
  type: typeof ALL_CLO_DEAL_MANAGER_SUCCESS;
  payload: Bixby.Models.BixbyError;
}

interface AddClientCloDealManager extends Bixby.Models.BixbyAction<undefined, typeof ADD_CLIENT_CLO_DEAL_MANAGER> {
  type: typeof ADD_CLIENT_CLO_DEAL_MANAGER;
}

interface AddClientCloDealManagerSuccess extends Bixby.Models.BixbyAction<undefined, typeof ADD_CLIENT_CLO_DEAL_MANAGER_SUCCESS> {
  type: typeof ADD_CLIENT_CLO_DEAL_MANAGER_SUCCESS;
}

interface AddClientCloDealManagerFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof ADD_CLIENT_CLO_DEAL_MANAGER_FAILURE> {
  type: typeof ADD_CLIENT_CLO_DEAL_MANAGER_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface DeleteClientCloDealManager extends Bixby.Models.BixbyAction<undefined, typeof DELETE_CLIENT_CLO_DEAL_MANAGER> {
  type: typeof DELETE_CLIENT_CLO_DEAL_MANAGER;
}

interface DeleteClientCloDealManagerSuccess extends Bixby.Models.BixbyAction<undefined, typeof DELETE_CLIENT_CLO_DEAL_MANAGER_SUCCESS> {
  type: typeof DELETE_CLIENT_CLO_DEAL_MANAGER_SUCCESS;
}

interface DeleteClientCloDealManagerFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof DELETE_CLIENT_CLO_DEAL_MANAGER_FAILURE> {
  type: typeof DELETE_CLIENT_CLO_DEAL_MANAGER_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type CloDealActionTypes =
  | AllCloDealManagerSuccess
  | AllCloDealManagerFailure
  | AddClientCloDealManager
  | AddClientCloDealManagerSuccess
  | AddClientCloDealManagerFailure
  | DeleteClientCloDealManager
  | DeleteClientCloDealManagerSuccess
  | DeleteClientCloDealManagerFailure
  | AllCloDealManagerLoading;
